import { theme } from '@by-miles/bymiles-styles'
import styled from 'styled-components'

export const CoverHighLightsStyles = styled.div`
  width: 100%;
  padding: 24px;
  border-radius: 8px;
  background: ${theme.primaryColours.white.main};

  @media (min-width: ${theme.grid.resolution.tablet.width}px) {
    width: ${theme.grid.resolution.tablet.container}px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 24px;
    align-items: initial;
    justify-content: initial;
    position: relative;

    &:after {
      content: '';
      position: absolute;
      background: ${theme.tints.aubergine};
      width: 1px;
      height: calc(100% - 48px);
      top: 24px;
      left: 33%;
    }
    &:before {
      content: '';
      position: absolute;
      background: ${theme.tints.aubergine};
      width: 1px;
      height: calc(100% - 48px);
      top: 24px;
      left: 66%;
    }
  }

  @media (min-width: ${theme.grid.resolution.desktop.width}px) {
    width: ${theme.grid.resolution.desktop.container}px;
  }

  .item-two {
    width: 200px;
  }

  .coverage-use-container {
    display: flex;
    width: auto;
    padding-right: ${theme.grid.spacing.base}px;
    .coverage-use-text {
      margin-top: ${theme.grid.spacing.s}px;
    }
    .info_icon {
      cursor: pointer;
      position: relative;
      top: ${theme.grid.spacing.s}px;
      margin-left: ${theme.grid.spacing.s}px;
    }
  }

  .border {
    border-bottom: ${theme.tints.aubergine} solid 1px;

    @media (max-width: ${theme.grid.resolution.tablet.width - 1}px) {
      &:nth-child(1) {
        padding-bottom: ${theme.grid.spacing.s}px;
      }
      &:nth-child(2) {
        padding-bottom: ${theme.grid.spacing.s}px;
        margin-top: ${theme.grid.spacing.s}px;
      }
      &:nth-child(3) {
        border-bottom: none;
        margin-top: ${theme.grid.spacing.s}px;
      }
    }

    @media (min-width: ${theme.grid.resolution.tablet.width}px) {
      border-bottom: none;
      padding-bottom: 0;
      margin-top: 0;
      position: relative;
      &:nth-child(2) {
        padding-left: 24px;
      }
    }
  }

  .item-one {
    width: 100px;
    @media (min-width: ${theme.grid.resolution.tablet.width}px) {
      width: auto;
      padding-right: 24px;
    }
  }

  .item-two {
    width: 205px;
    @media (min-width: ${theme.grid.resolution.tablet.width}px) {
      width: 220px;
      padding-right: 24px;
    }
    @media (min-width: ${theme.grid.resolution.desktop.width}px) {
      width: 250px;
    }
  }

  .item-three {
    @media (min-width: ${theme.grid.resolution.desktop.width}px) {
      width: 210px;
    }
  }
`
